import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

/**
 * The route for the admin pages - audit logs page.
 */
export const adminPagesAuditLogsRoute: InvariantJiraRoute = {
	name: 'global-settings-system-audit-logs',
	path: '/jira/settings/system/audit-logs',
	exact: true,
};
